// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"956":"366ccb1a","973":"7fe95281"}[chunkId] + ".chunk.css";
};